import React from 'react';
import { useStudioMode } from './StudioMode';
import StudioDeskPage from './StudioDeskPage';
import StudioModePlaceholder from './StudioModePlaceholder';

/**
 * The bare `/studio` route (spec SC8's home composition). `platform` mode renders the desk
 * (`GET /studio/desk` — Resume / Needs attention / Registry strip); `operator`/`author` render an
 * honest placeholder. `StudioHomePage` (the pre-desk five-tile grid) was deleted once the desk
 * superseded it; only its builder registry (`STUDIO_BUILDERS`) survives, as
 * `DeskRegistryStripMolecule`'s data source.
 */
const StudioModeHome: React.FC = () => {
  const { mode } = useStudioMode();
  return mode === 'platform' ? <StudioDeskPage /> : <StudioModePlaceholder />;
};

export default StudioModeHome;
